import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { Box, Grid } from '@mui/material';

const useStyles = makeStyles()(theme => ({
  formStyle: {
    borderRadius: '4px',
    border: `1px solid ${theme.palette.system.lightGrey}`,
    opacity: 1,
    background: `${theme.palette.system.lightGrey2} 0% 0% no-repeat padding-box`,
    paddingRight: '23px',
    marginBottom: '12px',
  },
  containerStyle: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  mainBodyContainer: {
    flexGrow: 1,
    flexDirection: 'column',
  },
  headerContainer: {
    fontSize: `16px !important`,
    margin: '10px 12px 8px 12px',
    fontWeight: 'bold',
  },
  subContainer: {
    margin: '0rem 0.75rem 0.75rem 0.75rem',
    display:'flex',
    flexDirection: 'column',
  }
}));

export const WrapperForExperience = ({ icon, title, children }: { title: string; children?; icon? }) => {
  const { classes } = useStyles();

  return (
    <form className={classes.formStyle}>
      <Grid container classes={{ root: classes.containerStyle }}>
        <Grid container item classes={{ root: classes.mainBodyContainer }}>
          <Grid item classes={{ root: classes.headerContainer }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
              {title} {icon}
            </Box>
          </Grid>
          <Grid container classes={{ root: classes.subContainer }}>{children}</Grid>
        </Grid>
      </Grid>
    </form>
  );
};
